import { SipOtherAssignmentCreateRequest } from "../../model/sipOtherAssignmentCreateRequest";
import { fetchPostJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipOtherAssignmentCreateRequest;

export async function postSipOtherAssignments(payload: DtoType) {
  try {
    const url = apiUrls.postSipOtherAssignments;
    return await fetchPostJSON(url, payload);
  } catch (err) {
    console.error("API Error - postSipOtherAssignments:", err);
  }
}
